import client from './client';

// QR오더 화면(고객용, 인증 불필요)에서 쓰던 조회/주문/회원로그인 함수들은 front-web(고객용
// 웹서비스)의 api/qrOrder.js 로 이관되었다 - 화면 자체가 그쪽으로 옮겨갔기 때문이다.
// 아래는 관리자 전용 함수만 남는다.

// ===================== 관리자용 =====================

export async function getTableOrderList(params) {
  const res = await client.get('/admin/table-order', { params });
  return res.data;
}

export async function getTableOrder(tableOrderId) {
  const res = await client.get(`/admin/table-order/${tableOrderId}`);
  return res.data;
}

export async function updateTableOrderStatus(tableOrderId, orderStatus, updatedBy) {
  const res = await client.put(`/admin/table-order/${tableOrderId}/status`, { orderStatus, updatedBy });
  return res.data;
}

/** 후결제(POSTPAID) 매장 주문을 정산완료 처리 (결제상태만 PAID로 변경, 주문상태는 그대로) */
export async function settleTableOrderPayment(tableOrderId, updatedBy) {
  const res = await client.put(`/admin/table-order/${tableOrderId}/settle-payment`, { updatedBy });
  return res.data;
}

/** 대시보드용 - 오늘 테이블오더 주문수 상위 매장 (기본 3개) */
export async function getTopStoresToday(limit = 3) {
  const res = await client.get('/admin/table-order/dashboard/top-stores', { params: { limit } });
  return res.data;
}

/** 매장관리자 대시보드용 - 이번 달 전체 주문수/오늘 주문수·주문금액/이번 주 최다 판매 상품 TOP10 */
export async function getStoreDashboardSummary() {
  const res = await client.get('/admin/table-order/dashboard/store-summary');
  return res.data;
}
